exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "header > div {\n  line-height: 60px;\n  padding: 0 20px;\n  cursor: pointer;\n}\n\n.is-active {\n  color: #313131;\n  background-color: #FFFFFF;\n}\n\n/* remove annoying dotted line in nav items */\n.is-active:focus, .is-active:active {\n  outline: 0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/navigation/navigation.component.css
// module id = 380
// module chunks = 1